import { render, staticRenderFns } from "./FCTable.vue?vue&type=template&id=fdbf8774&"
import script from "./FCTable.vue?vue&type=script&lang=js&"
export * from "./FCTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports